var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-cards-text"},[_c('h2',{class:_vm.headingStyle},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"fc-cards-text__body"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]),_vm._v(" "),_c('FCImage',{staticClass:"fc-cards-text__image",attrs:{"fc-provider":"storyblok","rounded":"","nuxt-image-props":{
      src: _vm.assets[0].src,
      alt: _vm.assets[0].alt,
      sizes: 'lg:800px',
      width: '800',
      height: '601',
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }